import { render, staticRenderFns } from "./payment-done-view.vue?vue&type=template&id=6c3a265e&scoped=true"
import script from "./payment-done-view.vue?vue&type=script&lang=js"
export * from "./payment-done-view.vue?vue&type=script&lang=js"
import style0 from "./payment-done-view.vue?vue&type=style&index=0&id=6c3a265e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a265e",
  null
  
)

export default component.exports